<!-- Navbar (Header) Starts -->
<nav
  class="header-navbar navbar navbar-expand-lg navbar-light bg-faded"
  *ngIf="user || company || hub || agency || employee"
>
  <div class="container-fluid container-fluid-customize d-flex">
    <div class="navbar-header" [ngClass]="{'margin-left-5': isUser}">
      <button
        type="button"
        class="navbar-toggle d-lg-none float-left"
        data-toggle="collapse"
        (click)="toggleSidebar()"
        *ngIf="isUser"
      >
        <span class="sr-only">Toggle navigation</span>
        <span class="icon-bar"></span>
        <span class="icon-bar"></span>
        <span class="icon-bar"></span>
      </button>

      <button
      type="button"
      class="navbar-toggle d-lg-none float-left"
      data-toggle="collapse"
      (click)="toggleNavbar()"
      *ngIf="isCompany || hub || agency || employee"
    >
      <span class="sr-only">Toggle navigation</span>
      <span class="icon-bar"></span>
      <span class="icon-bar"></span>
      <span class="icon-bar"></span>
    </button>
      <span
        class="nav-item mt-0 collapse navbar-collapse localsfy"
        [ngbCollapse]="isCollapsed"
      >
        <a class="nav-link position-relative" (click)="goMainPage()">
          <img
            src="assets/img/logo/logo_accent.png"
            alt="vyootrip logo"
            style="max-height: 3.5vh"
          />
        </a>
      </span>
    </div>
    <div
      class="options"
      *ngIf="
        authenticatedUser &&
        authenticatedUser.type?.toUpperCase() !== 'USER' &&
        (authenticatedUser.type?.toUpperCase() === 'COMPANY' && canInvite ? false : true)
      "
    >
      <div
        class="menu pointer"
        *ngIf="authenticatedUser && authenticatedUser.type?.toUpperCase() !== 'COMPANY'"
        (click)="navigate('/companies')"
      >
        {{ "navbar.start" | translate }}
      </div>
      <div
        placement="bottom-right"
        class="d-inline-block"
        ngbDropdown
        *ngIf="isEmployee || isHub || isAgency || isCompany"
      >
        <div
          *ngIf="isCompany === false"
          class="menu pointer text-center text-margin"
          ngbDropdownToggle
        >
          {{ "navbar.entity" | translate }}
          <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
            <a
              *ngIf="isEmployee"
              (click)="navigate('hubs')"
              class="dropdown-item text-left"
            >
              <span>{{ "navbar.hubs" | translate }}</span>
            </a>
            <a
              *ngIf="isEmployee || isHub"
              (click)="navigate('agencies')"
              class="dropdown-item text-left"
            >
              <span>{{ "navbar.partners" | translate }}</span>
            </a>
            <a
              *ngIf="isEmployee || isHub || isAgency"
              (click)="navigate('companies')"
              class="dropdown-item text-left"
            >
              <span>{{ "navbar.companies" | translate }}</span>
            </a>
          </div>
        </div>
      </div>


      <div
        class="menu pointer"
        *ngIf="authenticatedUser && authenticatedUser.type?.toUpperCase() === 'COMPANY'"
        (click)="navigate('/my-company/details')"
      >
        {{ "navbar.start" | translate }}
      </div>
      <div class="menu pointer" #btnReports id="nav-biuwer" (click)="goToDashboard(true)" *ngIf="isEmployee">
        {{ "company.company-detail.see-booked" | translate }}
      </div>
      <div
        #btnReports id="nav-biuwer"
        class="menu pointer"
        *ngIf="authenticatedUser && (authenticatedUser.type?.toUpperCase() === 'COMPANY' || authenticatedUser.type?.toUpperCase() === 'AGENCY')"
        (click)="
          goToDashboard(authenticatedUser.type?.toUpperCase() === 'COMPANY' || authenticatedUser.type?.toUpperCase() === 'AGENCY' ? false : true)
        "
      >
        {{ "company.company-detail.see-booked" | translate }}
      </div>
      <div
        class="menu pointer"
        *ngIf="isEmployee"
        [routerLink]="'/companies/plans'"
      >
        {{ "navbar.plans" | translate }}
      </div>
    <!--      
      <div class="menu pointer" *ngIf="!isUser">
            <a
              href="https://vyootrip.atlassian.net/servicedesk/customer/portals"
              target="_blank"
            >
              <span>{{ "common.support" | translate }}</span>
            </a>
      </div>
    -->
    </div>
    <div class="navbar-container navbar-container-customize">
      <div>
        <div *ngIf="isGroupAdmin || user != null" class="nav-options">
          <div
            *ngIf="isGroupAdmin"
            class="cursor-pointer d-flex flex-wrap"
            style="gap: 5px;"
            (click)="goToRequests()"
          >
            <b>
              {{ "common.authorizations" | translate }}
            </b>
            <span
              *ngIf="authService && authService.totalAuthorizations > 0"
              class="notification"
            >
              {{ authService.totalAuthorizations }}
            </span>
          </div>
          <div class="nav-item cursor-pointer ml-2"*ngIf="user != null">
            <b
              title="{{ 'common.storage' | translate }}"
              (click)="openUserStorage()"
            >
              {{ "common.storage" | translate }}
            </b>
          </div>
          <!-- 
            <div class="nav-item cursor-pointer" *ngIf="user != null">
            <a
              href="https://vyootrip.atlassian.net/servicedesk/customer/portals"
              target="_blank"
            >
              <b>
                {{ "common.support" | translate }}
              </b>
            </a>
          </div>
        -->
        </div>
        <div>
          <div class="nav-item">
            <span
              *ngIf="authenticatedUser"
              >{{
                authenticatedUser?.user
                  ? authenticatedUser?.user.name
                  : authenticatedUser?.name
              }}
              {{
                authenticatedUser?.user
                  ? authenticatedUser?.user.lastname
                  : authenticatedUser?.lastname
              }}
            </span>
          </div>
          <div
            class="nav-item circle"
            ngbDropdown
            placement="bottom-right"
            display="dynamic"
          >
            <a id="dropdownBasic3" ngbDropdownToggle class="dropdown-name">
              <ng-container *ngIf="cardImageBase64; else elseTemplate">
                <div class="user-image">
                  <img [src]="cardImageBase64" />
                </div>
              </ng-container>
              <ng-template #elseTemplate>
                <div class="user-image">
                  <div
                    class="profile-initials text-white"
                    *ngIf="authenticatedUser?.user?.name || authenticatedUser?.name">
                    {{
                      authenticatedUser?.user
                        ? authenticatedUser?.user.name[0] : (authenticatedUser?.name ? authenticatedUser?.name[0] : '')
                    }}
                  </div>
                </div>
              </ng-template>
              <img
                src="assets/img/svg/arrow-down.svg"
                style="width: 15%; padding-left: 0.3rem"
              />
            </a>
            <div
              ngbDropdownMenu
              aria-labelledby="dropdownBasic3 actions-dropdown"
              class="text-left"
            >
              <a class="dropdown-item" *ngIf="isEmployee" (click)="updateExpediaHotels()">
                Actualizar expedia
              </a>
              <a
                (click)="onEditUser()"
                *ngIf="isUser || isCompany || isAgency || isHub"
                class="dropdown-item"
                href="javascript:;"
              >
                <span>{{ "navbar.editUser" | translate }}</span>
              </a>
              <ng-container *ngIf="!canUseTRM && isCompany">
                <a
                  (click)="onEditCompany()"
                  class="dropdown-item"
                  href="javascript:;"
                >
                  <span>{{ "navbar.edit-company" | translate }}</span>
                </a>
                <a
                  (click)="onSendEmailUser()"
                  class="dropdown-item"
                  href="javascript:;"
                  *ngIf="canInvite"
                >
                  <span>{{ "navbar.send-email-user" | translate }}</span>
                </a>
                <a
                  *ngIf="isGroupAdmin"
                  (click)="navigate('/my-company/requests')"
                  class="dropdown-item"
                  href="javascript:;"
                >
                  <span>
                    {{ "common.authorizations" | translate }}
                  </span>
                  <span
                    *ngIf="totalAuthorizations && totalAuthorizations > 0"
                    class="notification"
                  >
                    {{ totalAuthorizations }}
                  </span>
                </a>
              </ng-container>
              <a
                target="blank"
                class="dropdown-item action-item"
                href="https://vyootrip.gitbook.io/vyootrip/"
              >
                <span>{{ "navbar.use-guide" | translate }}</span>
              </a>
              <a
                (click)="openProvidersModal()"
                *ngIf="isEmployee"
                class="dropdown-item action-item"
                href="javascript:;"
              >
                <span>{{ "common.providers" | translate }}</span>
              </a>
              <a
                (click)="editConfig()"
                *ngIf="isEmployee"
                class="dropdown-item action-item"
                href="javascript:;"
              >
                <span>{{ "employee.config.config" | translate }}</span>
              </a>
              <a
                (click)="editProviders()"
                *ngIf="isEmployee"
                class="dropdown-item action-item"
                href="javascript:;"
              >
                <span>{{ "employee.config.providers" | translate }}</span>
              </a>
              <a class="cursor-pointer" ngbDropdown [placement]="placement">
                <a
                  class="toggle-language action-item"
                  id="dropdownLang"
                  ngbDropdownToggle
                >
                  <span>{{ "common.language" | translate }}</span>
                  <img
                    src="assets/img/svg/arrow-down.svg"
                    style="width: 15%; padding-left: 0.3rem"
                  />
                </a>
                <div
                  ngbDropdownMenu
                  aria-labelledby="dropdownLang"
                  class="dropdownLang language-dropdown text-left"
                >
                  <a
                    class="dropdown-item py-1 lang"
                    href="javascript:;"
                    (click)="changeLanguage('es')"
                  >
                    <img
                      src="./assets/img/flags/es.svg"
                      class="language-icon"
                      alt="Spanish"
                    />
                    <span
                      [ngClass]="{ 'selected-language': language === 'es' }"
                      >{{ "navbar.spanish" | translate }}</span
                    >
                  </a>
                  <a
                    class="dropdown-item py-1 lang"
                    href="javascript:;"
                    (click)="changeLanguage('en')"
                  >
                    <img
                      src="./assets/img/flags/uk.svg"
                      class="language-icon"
                      alt="English"
                    />
                    <span
                      [ngClass]="{ 'selected-language': language === 'en' }"
                      >{{ "navbar.english" | translate }}</span
                    >
                  </a>
                </div>
              </a>
              <a
                (click)="logout()"
                class="dropdown-item action-item sign-out"
                href="javascript:;"
              >
                <img src="./assets/img/svg/sign-out-alt.svg" alt="language" />
                <span>{{ "common.sign-out" | translate }}</span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</nav>
<!-- Navbar (Header) Ends -->
